import {
    CREATE_NOTIFICATION_RULE_URL, GET_NOTIFICATION_PRIORITY_URL,
    GET_NOTIFICATION_EVENT_TRIGGER_URL,
    GET_NOTIFICATION_EVENT_TYPE_URL, GET_CONDITION_OPERATORS_URL,
    GET_CONDITION_FIELDS_URL, GET_RECIPIENT_TYPE_URL, GET_NOTIFICATION_URL,
    UPDATE_NOTIFICATION_RULE_URL
} from "@/utils/system_constants/constant.js";
import axios from "axios";
import {
    fetch_users as fetch_users_service,
    fetch_roles as fetch_roles_service
} from "@/services/user_service.js";
import { get_request_config } from "@/utils/system_constants/constant";
import NotificationStepper from "@/components/config_components/notifications/notification.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";

function get_notification_error_message(error, fallback) {
    return error.message || fallback;
}

export default {
    name: 'NotificationManagement',
    mixins: [alert_mixin],
    components: {
        NotificationStepper,
    },

    data: () => ({
        notification_view: "active",
        priority_options: [],
        operator_options: [],
        notifications: [],
        notification_search: '',
        users: [],
        user_roles: [],
        users_loading: false,
        recipient_type_options: [],
        field_options: [],
        event_trigger_options: [],
        event_type_options: [],
        notification: {
            name: "",
            description: "",
            priority: "Normal",
            event_type: "",
            event_trigger: "",
            conditions: [
                {
                    field: "",
                    operator: "equals",
                    value: ""
                }
            ],
            recipients: [
                {
                    type: "",
                    user_id: "",
                    role_id: "",
                    user_name: "",
                    cc: false,
                    required: true
                }
            ],
            channels: [],
            templates: [],
            is_active: true,
            project_id: null,
            section_question_id: null
        },
        selected_notification: {
            id: null,
            name: "",
            event_type: "",
            event_trigger: "",
            is_active: false,
            description: "",
            priority: "",
            channels: [],
            conditions: [],
            recipients: [],
            template: {
                subject: "",
                body: ""
            }
        },

        notification_message: {
            email: {
                subject: "",
                body: "",
            },
            sms: {
                subject: "",
                body: "",
            },
            in_app: {
                title: "",
                body: "",
            },
            webhook: {
                url: "",
                payload: "",
            },
        },
        loading: false,
        entity_types: [],
        entity_configs: [],
        selected_entity_type: "",
        selected_entity_configs: [],
        priority: "",

        active_step: 1,

        errors: {}
    }),

    mounted() {
        this.load_users();
        this.load_roles();

        this.get_notification_priorities();
        this.get_notification_event_triggers();
        this.get_notification_event_types();
        this.get_condition_operators();
        this.get_condition_field();
        this.get_recipient_type();
        this.get_notifications();
    },
    computed: {
        has_email() {
            return this.notification.channels.includes("EMAIL");
        },

        has_sms() {
            return this.notification.channels.includes("SMS");
        },

        has_in_app() {
            return this.notification.channels.includes("IN_APP");
        },

        has_webhook() {
            return this.notification.channels.includes("WEBHOOK");
        },
        filtered_notifications() {
    const notifications = Array.isArray(this.notifications)
        ? this.notifications
        : [];

    const search = String(this.notification_search || '')
        .trim()
        .toLowerCase();

    return notifications.filter((notification) => {

        const matches_status =
            this.notification_view === 'active'
                ? notification.is_active
                : !notification.is_active;

        if (!matches_status) {
            return false;
        }

        if (!search) {
            return true;
        }

        return (
            String(notification.name || '')
                .toLowerCase()
                .includes(search) ||

            String(notification.description || '')
                .toLowerCase()
                .includes(search) ||

            String(notification.event_type || '')
                .toLowerCase()
                .includes(search) ||

            String(notification.event_trigger || '')
                .toLowerCase()
                .includes(search)
        );
    });
},
        active_notifications() {
        return this.notifications.filter(notification =>
            notification.is_active === true ||
            notification.is_active === 1 ||
            notification.is_active === "true" ||
            notification.is_active === "1"
        );
    },

    inactive_notifications() {
        return this.notifications.filter(notification =>
            notification.is_active === false ||
            notification.is_active === 0 ||
            notification.is_active === "false" ||
            notification.is_active === "0"
        );
    },

    current_notification_count() {
        return this.notification_view === "active"
            ? this.active_notifications.length
            : this.inactive_notifications.length;
    }

    },
    methods: {
        nextStep() {
            if (this.validateStep()) {
                if (this.active_step < 5) {
                    this.active_step++;
                }
            }
        },
        previous_step() {
            if (this.active_step > 1) {
                this.active_step--;
            }
        },
        add_recipient_group() {
            this.notification.recipients.push({
                recipient_type: "",
                role_id: null,
                user_id: null,
                cc: false,
                required: true,
            });
        },
        remove_recipient(index) {
            this.notification.recipients.splice(index, 1);
        },
        open_notification_modal(notification) {
            if (!notification) {
                return;
            }

            this.selected_notification = {
                id: notification.id || null,
                name: notification.name || "",
                event_type: notification.event_type || "",
                event_trigger: notification.event_trigger || "",
                is_active: !!notification.is_active,
                description: notification.description || "",
                priority: notification.priority || "",

                channels: notification.channels || [],
                conditions: notification.conditions || [],
                recipients: notification.recipients || [],

                template: {
                    subject:
                        notification.subject ||
                        notification.template?.subject ||
                        "",

                    body:
                        notification.body ||
                        notification.template?.body ||
                        ""
                }
            };
            const modal_element = document.getElementById(
                "notification_details_modal"
            );
            if (!modal_element) {
                return;
            }
            const modal = bootstrap.Modal.getOrCreateInstance(
                modal_element
            );
            modal.show();
        },
        add_condition() {
            this.notification.conditions.push({
                entity_type: "",
                field: "",
                operator: "equals",
                value: "",
                logical_group: "AND",
            });
        },
        remove_condition(index) {
            this.notification.conditions.splice(index, 1);
        },

        build_notification_templates() {
            const templates = [];
            const msg = this.notification_message;
            const channels = this.notification.channels;

            if (channels.includes("EMAIL")) {
                templates.push({
                    channel: "EMAIL",
                    subject: msg.email.subject,
                    body: msg.email.body
                });
            }

            if (channels.includes("SMS")) {
                templates.push({
                    channel: "SMS",
                    subject: msg.sms.subject,
                    body: msg.sms.body
                });
            }

            if (channels.includes("IN_APP")) {
                templates.push({
                    channel: "IN_APP",
                    subject: msg.in_app.title,
                    body: msg.in_app.body
                });
            }

            if (channels.includes("WEBHOOK")) {
                templates.push({
                    channel: "WEBHOOK",
                    subject: msg.webhook.url,
                    body: msg.webhook.payload
                });
            }

            this.notification.templates = templates;
        },
        async create_notification_rule() {
            const payload = this.notification;
            try {
                this.loading = true;

                this.build_notification_templates();

               const cleanRecipients = this.notification.recipients.map(r => ({
                    recipient_type: r.recipient_type,
                    user_id: r.user_id === "" ? null : r.user_id,
                    role_id: r.role_id === "" ? null : r.role_id,
                    cc: r.cc,
                    required: r.required,
                }));
                const cleanConditions = this.notification.conditions.filter(
                    c => c.field && c.field.trim() !== ""
                );

                const payload = {
                    name: this.notification.name,
                    description: this.notification.description,
                    priority: this.notification.priority,
                    is_active: this.notification.is_active,
                    event_type: this.notification.event_type,
                    event_trigger: this.notification.event_trigger,
                    conditions: cleanConditions,
                    recipients: cleanRecipients,
                    channels: this.notification.channels,
                    templates: this.notification.templates,
                    project_id:
                        this.notification.project_id === "" ? null : this.notification.project_id,
                    section_question_id:
                        this.notification.section_question_id === "" ? null : this.notification.section_question_id,
                };
                const response = await axios.post(
                    CREATE_NOTIFICATION_RULE_URL,
                    payload,
                    get_request_config()
                );

                if (response.data.status === "success") {
                    this.show_success(
                        "Notification created successfully.",
                        "success"
                    );
                    this.reset_notification();
                    this.active_step = 1;
                    await this.get_notifications();
                }

            } catch (error) {
                this.show_error(error, "Error creating notification");
            } finally {
                this.loading = false;
            }
            return payload;
        },
        get_recipient_type_label(type) {
            const recipient_type = this.recipient_type_options.find(
                item => item.value === type
            );
            return recipient_type
                ? recipient_type.label
                : type || "Not specified";
        },
        get_recipient_user_name(user_id) {
            if (!user_id) {
                return "Not specified";
            }
            const user = this.users.find(
                item => String(item.id) === String(user_id)
            );
            return user
                ? user.name
                : "Unknown User";
        },
        get_recipient_role_name(role_id) {
            if (!role_id) {
                return "Not specified";
            }
            const role = this.user_roles.find(
                item => String(item.id) === String(role_id)
            );
            return role
                ? role.role
                : "Unknown Role";
        },
        async get_notification_priorities() {
            const response = await axios
                .get(GET_NOTIFICATION_PRIORITY_URL, get_request_config())
                .catch((error) => {
                    this.show_error(
                        get_notification_error_message(
                            error,
                            "Failed to load notification priorities."
                        )
                    );
                    return null;
                })
                .finally(() => (this.loading = false));

            if (!response) {
                return;
            }

            const { data } = response;
            if (data?.status === "success") {
                this.priority_options = data.data || [];
                return;
            }

            this.show_error(data?.message || "Failed to load notification priorities.");
        },
        async update_notification() {

            const loader = await this.show_loader(
                "Updating notification..."
            );

            try {

                const payload = {
                    id: this.selected_notification.id,
                    name: this.selected_notification.name,
                    description: this.selected_notification.description || "",
                    priority: this.selected_notification.priority || "",
                    event_type: this.selected_notification.event_type || "",
                    event_trigger: this.selected_notification.event_trigger || "",
                    is_active: this.selected_notification.is_active,
                    conditions: this.selected_notification.conditions.map(condition => ({
                        id: condition.id || null,
                        field: condition.field || condition.field_name || "",
                        operator: condition.operator || "=",
                        value: condition.value || "",
                        logical_group: condition.logical_group || "AND"
                    })),

                    recipients: this.selected_notification.recipients.map(recipient => ({
                        id: recipient.id || null,
                        recipient_type: recipient.recipient_type,
                        user_id: recipient.user_id || null,
                        role_id: recipient.role_id || null,
                        cc: recipient.cc || false,
                        required: recipient.required !== undefined
                            ? recipient.required
                            : true
                    })),
                    channels: this.selected_notification.channels,
                    templates: this.selected_notification.templates
                };

                await axios.post(
                    UPDATE_NOTIFICATION_RULE_URL,
                    payload,
                    get_request_config()
                );

                this.show_success(
                    "Notification updated successfully"
                );

                const modalEl = document.getElementById("notification_details_modal");
                if (modalEl) {
                    bootstrap.Modal.getOrCreateInstance(modalEl).hide();
                }

                await this.get_notifications();

            } catch (error) {

                this.show_error(
                    "Notification update error:",
                    error
                );
            } finally {

                await this.close_loader(loader);
            }
        },
        addCondition() {
            this.selected_notification.conditions.push({
                id: null,
                field: "",
                operator: "=",
                value: "",
                logical_group: "AND"
            });
        },

        addRecipient() {
            this.selected_notification.recipients.push({
                id: null,
                recipient_type: "user",
                user_id: null,
                role_id: null,
                cc: false,
                required: true
            });
        },
        removeCondition(index) {
            this.selected_notification.conditions.splice(index, 1);
        },
        removeRecipient(index) {
            this.selected_notification.recipients.splice(index, 1);
        },
        build_update_notification_payload() {

            const notification = this.selected_notification;

            const payload = {
                id: notification.id,

                name: notification.name,
                description: notification.description,
                priority: notification.priority,

                event_type: notification.event_type,
                event_trigger: notification.event_trigger,

                is_active: notification.is_active,

                channels: (notification.channels || []).map(channel => {
                    return typeof channel === "object"
                        ? channel.channel
                        : channel;
                }),

                recipients: (notification.recipients || []).map(recipient => {

                    const data = {
                        id: recipient.id,
                        recipient_type: recipient.recipient_type
                    };

                    if (recipient.recipient_type === "user") {
                        data.user_id = recipient.user_id;
                        data.role_id = null;
                    }

                    if (recipient.recipient_type === "role") {
                        data.role_id = recipient.role_id;
                        data.user_id = null;
                    }

                    return data;
                }),

                conditions: (notification.conditions || []).map(condition => ({
                    id: condition.id,

                    field: condition.field ||
                        condition.field_name ||
                        condition.condition_field_id,

                    operator: condition.operator,

                    value: condition.value
                })),

                template: {
                    subject:
                        notification.template?.subject || "",

                    body:
                        notification.template?.body || ""
                }
            };
            return payload;
        },
        async get_condition_operators() {
            const payload = {}
            try {
                const { data } = await axios.get(
                    GET_CONDITION_OPERATORS_URL,
                    get_request_config(payload)
                );

                if (data?.status === "success") {
                    this.operator_options = data.data || [];
                    return;
                }

                this.show_error(
                    data?.message || "Failed to load condition operators."
                );
            } catch (error) {
                this.show_error(
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to load condition operators."
                );
            } finally {
                this.loading = false;
            } return payload
        },
        async get_notification_event_triggers() {
            const payload = {}
            try {
                const { data } = await axios.get(
                    GET_NOTIFICATION_EVENT_TRIGGER_URL,
                    get_request_config(payload)
                );
                if (data?.status === "success") {
                    this.event_trigger_options = data.data || [];
                    return;
                }
                this.show_error(
                    data?.message || "Failed to load notification event triggers."
                );
            } catch (error) {
                this.show_error(
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to load notification event triggers."
                );
            } finally {
                this.loading = false;
            } return payload
        },
      async load_users() {
            const result = await fetch_users_service().catch((error) => {
                this.users = [];
                this.show_error(
                    error.message || "Failed to load users."
                );
                return null;
            });

            if (result) {
                this.users = result.users;
            }
        },

        async load_roles() {
            this.user_roles = await fetch_roles_service().catch((error) => {
                this.show_error(
                    error.message || "Failed to load user roles."
                );
                return [];
            });
        },
        async recipient_type_changed(recipient) {
    recipient.user_id = null;
    recipient.role_id = null;

    try {
        if (recipient.recipient_type === "user") {
            await this.load_users();
        }

        if (recipient.recipient_type === "role") {
            await this.load_roles();
        }
    } catch {
        this.show_error("Failed to load recipients.");
    }
},
        async get_notification_event_types() {
            const payload = {}
            try {
                const { data } = await axios.get(
                    GET_NOTIFICATION_EVENT_TYPE_URL,
                    get_request_config(payload)
                );
                if (data?.status === "success") {
                    this.event_type_options = data.data || [];
                    return;
                }
                this.show_error(
                    data?.message || "Failed to load notification event types."
                );
            } catch (error) {
                this.show_error(
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to load notification event types."
                );
            } finally {
                this.loading = false;
            } return payload
        },
        async get_recipient_type() {
            const payload = {}
            try {
                const { data } = await axios.get(
                    GET_RECIPIENT_TYPE_URL,
                    get_request_config(payload)
                );
                if (data?.status === "success") {
                    this.recipient_type_options = data.data || [];
                    return;
                }
                this.show_error(
                    data?.message || "Failed to load recipient types."
                );
            } catch (error) {
                this.show_error(
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to load recipient types."
                );
            } finally {
                this.loading = false;
            } return payload
        },
        async get_condition_field() {
            const payload = {}
            try {
                const { data } = await axios.get(
                    GET_CONDITION_FIELDS_URL,
                    get_request_config(payload)
                );
                if (data?.status === "success") {
                    this.field_options = data.data || [];
                    return;
                }
                this.show_error(
                    data?.message || "Failed to load condition fields."
                );
            } catch (error) {
                this.show_error(
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to load condition fields."
                );
            } finally {
                this.loading = false;
            } return payload
        },
        reset_notification() {
            this.notification = {
                name: "",
                description: "",
                priority: "Normal",
                event_type: "",
                event_trigger: "",

                conditions: [
                    {
                        field: "",
                        operator: "equals",
                        value: ""
                    }
                ],
                recipients: [
                    {
                        recipient_type: "",
                        user_id: null,
                        role_id: null,
                        user_name: "",
                        cc: false,
                        required: true
                    }
                ],
                channels: [],
                templates: [],
                is_active: true,
                project_id: null,
                section_question_id: null
            };
            this.notification_message = {
                email: {
                    subject: "",
                    body: ""
                },
                sms: {
                    message: ""
                },
                in_app: {
                    title: "",
                    message: ""
                },
                webhook: {
                    url: "",
                    payload: ""
                }
            };
            this.selected_entity_type = "";
            this.selected_entity_configs = [];
            this.errors = {};
            this.active_step = 1;
        },
        async get_notifications() {
            const payload = {}
            try {
                const { data } = await axios.get(
                    GET_NOTIFICATION_URL,
                    get_request_config(payload)
                );
                if (data?.status === "success") {
                    this.notifications = data.data || [];
                    return;
                }
                this.show_error(
                    data?.message || "Failed to load notifications."
                );
            } catch (error) {
                this.show_error(
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to load notifications."
                );
            } finally {
                this.loading = false;
            } return payload
        },
        validateStep() {
            this.errors = {};

            if (this.active_step === 1) {
                if (!this.notification.name) {
                    this.errors.name = "Name is required.";
                }

                if (!this.notification.priority) {
                    this.errors.priority = "Priority is required.";
                }
            }

            return true;
        },
    }
}
